// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2084 ? "9b0008ae" : chunkId) + "." + {"1646":"510ae2f2cc90e781","2084":"646eb00caecc030b","5139":"715107020b82813d","5376":"2ff82d5f5063c11b"}[chunkId] + ".js";
};